// @flow
import * as React from 'react';
import { getCardWidth } from 'app/common/react/components/profile/ProfileBoardCard/layout';
import { Box, Mask, Image } from 'gestalt';

type Props = {|
  pins: Array<Object>,
|};

// Amount of pixels between items
const SPACING = 2;
const THUMB_SIZE_KEY = '170x';

export default function SquareProductGroupCollage({ pins = [] }: Props) {
  const width = getCardWidth('square');
  const height = width;
  const thumbWidth = width / 2 - SPACING / 2;
  const thumbHeight = height / 2 - SPACING / 2;

  return (
    <Mask shape="rounded" width={width} height={height}>
      <Box display="flex" wrap>
        {pins.map((pin, index) => (
          <Box
            dangerouslySetInlineStyle={{
              __style: {
                marginBottom: index === 0 || index === 1 ? SPACING : 0,
                marginRight: index === 0 || index === 2 ? SPACING : 0,
              },
            }}
            key={`square-product-group-collage-${index}`}
          >
            {pin && pin.images[THUMB_SIZE_KEY].url !== '' ? (
              <Mask wash height={thumbHeight} width={thumbWidth}>
                <Image
                  alt={pin.title}
                  src={pin.images[THUMB_SIZE_KEY].url || ''}
                  naturalWidth={pin.images[THUMB_SIZE_KEY].width || 1}
                  naturalHeight={pin.images[THUMB_SIZE_KEY].height || 1}
                  fit="cover"
                />
              </Mask>
            ) : (
              <Box color="lightGray" width={thumbWidth} height={thumbHeight} />
            )}
          </Box>
        ))}
      </Box>
    </Mask>
  );
}
